/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LineWithDot/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LineWithDot({
  children,
  viewPath = "/DesignSystem/VerticalTimeline/VerticalTimelineForm/LineWithDot"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let timelineLineColorValueData = fromData.useDataValue({ viewPath,
context: 'timeline',
path: 'lineColor',
})
let timelineDotColorValueData = fromData.useDataValue({ viewPath,
context: 'timeline',
path: 'dotColor',
})
let timelineLineColorValueData1 = fromData.useDataValue({ viewPath,
context: 'timeline',
path: 'lineColor',
})
let timelineEventItemIsLastValueData = fromData.useDataFormat({ viewPath,
context: 'timeline_event_item',
path: 'isLast',
format: fromFormat.not,
})
  return (<React.Fragment
>
<div
  data-testid="LineWithDot.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z12TKcR': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="LineWithDot.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-Z12TKcR': timelineLineColorValueData,'--bc-3-Z12TKcR': timelineDotColorValueData}}
 className={`views-block ${styles.Vertical1}`}
/>
<fromFlow.When is={timelineEventItemIsLastValueData}>
<div
  data-testid="LineWithDot.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-Z12TKcR': timelineLineColorValueData1}}
 className={`views-block ${styles.Vertical2}`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}